module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.e68987a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/singapore/font/AmwayIcons.eot?5v2gxx
// module id = 3vKW
// module chunks = 0